import { useState, useRef, useEffect } from 'react';

interface AnimatedCounterProps {
  end: number;
  duration?: number;
  suffix?: string;
  trigger?: boolean;
  [key: string]: unknown;
}

export const AnimatedCounter = ({
  end,
  duration = 1200,
  suffix = '',
  trigger = false,
  ...props
}: AnimatedCounterProps) => {
  const [count, setCount] = useState(0);
  const ref = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    if (!trigger) return;
    let start = 0;
    const increment = end / (duration / 16);
    let frame: number;
    const step = () => {
      start += increment;
      if (start < end) {
        setCount(Math.floor(start));
        frame = requestAnimationFrame(step);
      } else {
        setCount(end);
      }
    };
    frame = requestAnimationFrame(step);
    return () => cancelAnimationFrame(frame);
  }, [end, duration, trigger]);

  return (
    <span ref={ref} {...props}>
      {count.toLocaleString()}
      {suffix}
    </span>
  );
};
